// ABOUTME: Creates the TanStack Router instance from the auto-generated route tree.
// ABOUTME: Exports the typed router and registers it for type-safe navigation.

import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const router = createRouter({
  routeTree,
  // biome-ignore lint/style/noNonNullAssertion: provided at runtime by App.tsx via RouterProvider context
  context: { auth: undefined! },
  defaultPreload: "intent",
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
